import React, { FC, memo, useEffect } from "react";
import { useGetConfigQuery } from "@store/avatarApi";
import HeygenAvatar from "@components/HeygenAvatar/HeygenAvatar";
import {
  AudioAvatarConfig,
  AvatarType,
  AzureAvatarConfig,
  HeygenAvatarConfig,
} from "@models/avatar-config";
import AzureAvatar from "@components/AzureAvatar/AzureAvatar";
import AudioAvatar from "@components/AudioAvatar/AudioAvatar";
import { useGetAppConfigQuery } from "@store/appConfigApi";
import { useDispatch } from "react-redux";
import { setLoadingConfig } from "@store/avatarSlice";

const Avatar: FC<{
  sessionId: string;
  photoId?: string;
  companionName: string;
}> = ({ sessionId, photoId, companionName }) => {
  const dispatch = useDispatch();
  const { data: avatarConfig, isLoading: isLoadingAvatarConfig } =
    useGetConfigQuery(sessionId);
  const { data: appConfig, isLoading: isLoadingAppConfig } =
    useGetAppConfigQuery();

  useEffect(() => {
    dispatch(setLoadingConfig(isLoadingAvatarConfig || isLoadingAppConfig));
  }, [isLoadingAvatarConfig, isLoadingAppConfig, dispatch]);

  if (!avatarConfig || !appConfig) {
    return null;
  }

  return (
    <>
      {avatarConfig.type === AvatarType.Heygen ? (
        <HeygenAvatar
          sessionId={sessionId}
          photoId={photoId}
          avatarConfig={avatarConfig as HeygenAvatarConfig}
          streaming={appConfig.streamingEnabled}
        />
      ) : avatarConfig.type === AvatarType.Audio ? (
        <AudioAvatar
          sessionId={sessionId}
          photoId={photoId}
          avatarConfig={avatarConfig as AudioAvatarConfig}
          streaming={appConfig.streamingEnabled}
        />
      ) : (
        <AzureAvatar
          sessionId={sessionId}
          photoId={photoId}
          avatarConfig={avatarConfig as AzureAvatarConfig}
          streaming={appConfig.streamingEnabled}
          companionName={companionName}
        />
      )}
    </>
  );
};

export default memo(Avatar);
